import { useLocation } from 'react-router-dom';

export const useQuery = (shouldToLower = false) => {
  const location = useLocation();
  if (shouldToLower) {
    return new URLSearchParams(location.search.toLocaleLowerCase());
  }
  return new URLSearchParams(location.search);
};
